/***
*
*   USERS
*   Manage individual users registered to your application
*
**********/

import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import Settings from 'settings';
import { ViewContext, AuthContext, Card, Table, Animate, useAPI, useUserEmails } from 'components/lib';

export function Users(props) {

  const viewContext = useContext(ViewContext);
  const authContext = useContext(AuthContext);

  const users = useAPI('/api/user');
  const userEmails = useUserEmails();

  const [userList, setUserList] = useState([]);

  useEffect(() => {
    if (userEmails?.data) {
      setUserList(userEmails.data)
    }
  }, [userEmails?.data]);

  function editUser(data, callback) {
    viewContext.modal.show({

      title: 'Edit User',
      form: {
        name: {
          label: 'Name',
          type: 'text',
          value: data.name,
          required: true,
        },
        email: {
          label: 'Email',
          type: 'email',
          value: data.email,
          required: true
        }
      },
      buttonText: 'Save',
      url: `/api/user/${data.id}`,
      method: 'PATCH'

    }, (res) => {

      viewContext.notification.show(data.name + ' was updated', 'success', true);
      callback(res);

    });
  }

  function deleteUser(data, callback) {
    viewContext.modal.show({
      title: 'Delete User',
      form: {},
      buttonText: 'Delete User',
      text: `Are you sure you want to delete ${data.email}? This will remove them from all accounts.`,
      url: `${authContext.remote_server}/api/user/${data.id}`,
      method: 'DELETE',
      destructive: true,

    }, () => {

      viewContext.notification.show(`${data.email} was deleted`, 'success', true);
      callback();

    });
  }

  async function impersonateUser(data) {

    try {

      const res = await Axios.post(`/api/user/impersonate/${data._id}`);
      const token = res.data?.data?.token;
      if (token) {

        window.location = Settings[process.env.REACT_APP_YOSUITE_ENV_MODE].remote_client + `/signin/impersonate?token=${token}`

      }
    }
    catch (err) {

      viewContext.handleError(err);

    }
  }

  return (
    <Animate>
      <Card>
        <Table
          search
          data={users.data?.users}
          loading={users.loading}
          show={['name', 'email', 'date_created', 'last_active', 'onboarded', 'verified', 'avatar']}
          actions={{

            view: { url: `/users`, col: 'id' },
            edit: editUser,
            delete: deleteUser,
            email: true,
            custom: [{ icon: 'log-in', action: impersonateUser }]

          }}

          searchableDropdownData={
            [
              {
                label: 'Email',
                name: 'email',
                placeholder: ' user email',
                options: userList?.list
              },
            ]
          }
        />
      </Card>
    </Animate>
  );
}
